import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-boxberry",
  "use": "icon-boxberry-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-boxberry\">\n    <path fill-rule=\"evenodd\" d=\"M18.208 3a1 1 0 0 1 .82.428l2.792 4c.135.193.19.408.18.614V20a1 1 0 0 1-.883.993L21 21H3a1 1 0 0 1-.993-.883L2 20V7.946a.991.991 0 0 1 .166-.498l2.648-4A1 1 0 0 1 5.648 3zM20 9h-5v4a1 1 0 0 1-.883.993L14 14h-4a1 1 0 0 1-1-1V9H4v10h16V9zm-7 0h-2v3h2V9zm4.686-4H6.185L4.861 7h14.221l-1.396-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol